import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import products from "features/productsSlice";
import carts from "features/cartsSlice";
import user from "features/userSlice";
import styles from "features/styleSlice";
import invoices from "features/invoicesSlice";
import purchaseOrders from "features/purchaseOrdersSlice";
import { baseApi } from "features/baseApi";
import webSocketMiddleware from "features/webSocketMiddleware";
import dgiApiWebSocketMiddleware from "features/dgiApiWebSocketMiddleware";
import goApiWebSocketMiddleware from "features/goApiWebSocketMiddleware";
import autoAddReducer from "../features/autoAddSlice";
import composerReducer from "../features/composerSlice";
import fastEntryReducer from "../features/fastEntrySlice";
import highlightReducer from "../features/highlightSlice";
import { createComposerMiddleware } from "../features/composerMiddleware";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"], // only persist user slice
};

const persistedUserReducer = persistReducer(persistConfig, user);

// Create sendPayload function for the composer middleware
const sendPayload = (payload) => {
  // This will dispatch to the WebSocket middleware
  store.dispatch({
    type: "DGI_API_WEBSOCKET_SEND",
    payload,
  });
};

// Create the middleware
const composerMiddleware = createComposerMiddleware(sendPayload);

export const store = configureStore({
  reducer: {
    products: products,
    carts: carts,
    user: persistedUserReducer,
    styles: styles,
    [baseApi.reducerPath]: baseApi.reducer,
    invoices: invoices,
    autoAdd: autoAddReducer,
    purchaseOrders: purchaseOrders,
    composer: composerReducer,
    fastEntry: fastEntryReducer,
    highlight: highlightReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    })
      .concat(webSocketMiddleware)
      .concat(dgiApiWebSocketMiddleware)
      .concat(goApiWebSocketMiddleware)
      .concat(baseApi.middleware)
      .concat(composerMiddleware),
});

export default store;